import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import ReduxGlobal from '../../../../../store/actionreducers/globalView'
import ReduxAdminMedical from '../../../../../store/actionreducers/adminMedical/medical'
import { withStyles } from '@material-ui/core/styles'
import moment from 'moment'
import AgendaTable from './agenda/AgendaTable'
import { UecareDropdown } from '../../../../../components'

const SPECIALIST_CLINIC_OPTIONS = [
    { name: '一般門診', id: 3 },
    { name: '快篩陽性確診', id: 14 },
];

const AgendaTab = props => {
    const {
        classes,
        medical,
        workEvents,
        openAlertDialog,
        getWorkEventsByMonth,
        putWorkEventsByMonth,
    } = props
    const { id, job } = medical

    const defaultMptId = job.id === 2 ? 3 : job.id === 4 ? 13 : 3  

    const [mptId, setMptId] = useState(defaultMptId)
    const [date, setDate] = useState(moment())
    const [tableMode, setTableMode] = useState('view')
    const [isLoading, setLoading] = useState(false)

    const month = date.format('YYYY-MM')
    const getWorkEventsByMonthCallback = useCallback(() => {
        Promise.resolve()
            .then(() => setLoading(true))
            .then(() => getWorkEventsByMonth({ id, month }))
            .then(() => setLoading(false))
    }, [id, month])

    useEffect(() => {
        getWorkEventsByMonthCallback()
    }, [getWorkEventsByMonthCallback])

    const onSave = (date, events) => {
        const newEvents = events.map(e => ({...e, mptId}))
        const otherEvents = workEvents
        .filter(e => !moment(e.date).isSame(date, 'day') || e.fk_mpt_id !== mptId)
        .map(e => ({
            breakTime: e.breakTime || e.break_time,
            currencyId: e.currencyId || e.currency_id,
            date: moment(e.date).format('YYYY-MM-DD'),
            markedPriceCent: e.markedPriceCent || e.marked_price_cent,
            mptId: e.fk_mpt_id,
            timePeriodId: e.fk_time_period_id,
            workTime: e.work_time
        }))
        putWorkEventsByMonth({ id, month, workEvents: [...newEvents, ...otherEvents] })
    }

    const filteredEvents = workEvents.filter(e => e.fk_mpt_id === mptId)
    return <div>
        <UecareDropdown
            label="排班類型"
            icon="assignment"
            name="mpt"
            id="mpt"
            className={classes.formControl}
            value={mptId}
            options={SPECIALIST_CLINIC_OPTIONS}
            onChange={event => setMptId(event.target.value)}
        />
        <AgendaTable
            mptId={mptId}
            date={date}
            mode={tableMode}
            isLoading={isLoading}
            onCancelButtonClick={() => setTableMode('view')}
            onChangeLostConfirm={() => new Promise(resolve => openAlertDialog({
                title: '離開排班畫面',
                message: `若您尚未儲存，您所填寫的班表將會遺失，請問您是否要離開?`,
                yesButton: {
                    label: '是',
                    onClick: () => resolve(true),
                },
                noButton: {
                    label: '否',
                    onClick: () => resolve(false),
                },
            }))}
            onDateUpdate={newDate => setDate(newDate.clone())}
            onRefreshRequested={() => getWorkEventsByMonthCallback()}
            onEditButtonClick={() => setTableMode('edit')}
            onSaveButtonClick={onSave}
            workEvents={filteredEvents}/>
    </div>
}

const styles = () => ({
    container: {
        textAlign: 'center',
    },
    textField: {
        marginLeft: 10,
        marginRight: 10,
    },
    formControl: {
        marginBottom: 24,
        width: 'auto'
    }
})

const mapDispatchToProps = dispatch => bindActionCreators({
    ...ReduxGlobal.ActionCreator,
    ...ReduxAdminMedical.ActionCreator,
}, dispatch)

const mapStateToProps = ({ adminMedicalList: { workEvents } }) => ({
    workEvents,
})

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AgendaTab)))



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/tabs/AgendaTab.js